var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4396_10839",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4396_10839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 4.66667V12.6667C13.9961 13.0333 13.8655 13.3472 13.6044 13.6083C13.3433 13.8694 13.0294 14 12.6628 14H3.32943C2.96276 14 2.64887 13.8694 2.38776 13.6083C2.12665 13.3472 1.99609 13.0333 1.99609 12.6667V3.33333C1.99609 2.96667 2.12665 2.65278 2.38776 2.39167C2.64887 2.13056 2.96276 2 3.32943 2H11.3294L13.9961 4.66667ZM12.6628 5.23333L10.7628 3.33333H3.32943V12.6667H12.6628V5.23333ZM7.99609 12C8.55165 12 9.02387 11.8056 9.41276 11.4167C9.80165 11.0278 9.99609 10.5556 9.99609 10C9.99609 9.44444 9.80165 8.97222 9.41276 8.58333C9.02387 8.19444 8.55165 8 7.99609 8C7.44054 8 6.96832 8.19444 6.57943 8.58333C6.19054 8.97222 5.99609 9.44444 5.99609 10C5.99609 10.5556 6.19054 11.0278 6.57943 11.4167C6.96832 11.8056 7.44054 12 7.99609 12ZM3.99609 6.66667H9.99609V4H3.99609V6.66667Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.740bb7b7b50a50b4a851c442e98a6606.svg";
export { ForwardRef as ReactComponent };